var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"transition-opacity duration-200",class:_vm.loaded ? '' : 'opacity-0',attrs:{"src":_vm.thumb,"alt":_vm.alt},on:{"error":_vm.onError,"load":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }